import React, { useEffect } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

import queryString from 'query-string';

import { useAuth } from '@/hooks/useAuth';
import { NonMemberAuthStorage } from '@/utils';

export interface ProtectedRouteProps {
  needAuth?: boolean;
  needNonMemberAuth?: boolean;
  children: React.ReactNode;
}

const Redirect = () => {
  const { pathname } = useLocation();
  const { REACT_APP_LINK_CLIENT_URL } = process.env;

  useEffect(() => {
    const redirectTo = `${REACT_APP_LINK_CLIENT_URL}/customer/login?redirect=${encodeURIComponent(
      `${pathname}?payment=true`,
    )}`;
    window.location.href = redirectTo;
  }, []);

  return <React.Fragment />;
};

export function ProtectedRoute({
  needAuth = false,
  needNonMemberAuth = false,
  children,
}: ProtectedRouteProps) {
  const { loggedIn } = useAuth();
  const params = useParams();
  const query = queryString.parse(useLocation().search);
  const isAvailable = new NonMemberAuthStorage().isAvailable();

  if (needAuth && !loggedIn) return <Redirect />;
  if (needNonMemberAuth && !isAvailable) {
    const { id } = params;
    const { phone, orderNumber } = query as unknown as {
      phone: number;
      orderNumber: string | null;
    };

    const queryParams = new URLSearchParams({
      phone: phone as unknown as string,
      orderNumber: (id as string) ?? orderNumber,
    }).toString();
    return <Navigate to={`/anonymous?${queryParams}`} />;
  }

  return <React.Fragment>{children}</React.Fragment>;
}
